import { render, staticRenderFns } from "./classificationA.vue?vue&type=template&id=a9fe7ce0&scoped=true"
import script from "./classificationA.vue?vue&type=script&lang=js"
export * from "./classificationA.vue?vue&type=script&lang=js"
import style0 from "./classificationA.vue?vue&type=style&index=0&id=a9fe7ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fe7ce0",
  null
  
)

export default component.exports